import { Flex } from '@chakra-ui/react';
import { useMyDispositionsContext } from '../context';
import { useSearchParams } from 'react-router';
import { formatPhoneNumber } from '@utils/formats';
import FilterTag from '@components/FilterTag';

const PARAMS_LABELS = {
  name: 'Nome',
  email: 'E-mail',
  taxId: 'CPF',
  phoneNumber: 'Telefone',
};

const SelectedFiltersList = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const params = Object.fromEntries(searchParams.entries());
  const paramsKeys = Object.keys(params).filter((key) => !['limit', 'page'].includes(key));

  const { getMyDispositionsList } = useMyDispositionsContext();

  const onRemoveFilter = async (key: string) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.delete(key);
    setSearchParams(newParams);

    const filteredParams = Object.fromEntries(newParams.entries());

    await getMyDispositionsList({
      ...filteredParams,
    });
  };

  return (
    <Flex gap={2}>
      {paramsKeys.map((key) => (
        <FilterTag
          key={key}
          label={PARAMS_LABELS[key as keyof typeof PARAMS_LABELS]}
          value={key === 'phoneNumber' ? formatPhoneNumber(params[key]) : params[key]}
          onRemove={() => onRemoveFilter(key)}
        />
      ))}
    </Flex>
  )
};

export default SelectedFiltersList;
